import { Badge, IconButton, Icons } from '@commenda/kakashi';
import { WorkflowCanvasRefreshHelper } from './helpers/canvas-refresh';

export type TCanvasStatusBadgeProps = {
  isRefreshing: boolean;
  lastUpdatedAt: Date | null;
  isEditInProgress: boolean;
  onRefreshNow: () => void;
};

export const CanvasStatusBadge = ({
  isRefreshing,
  lastUpdatedAt,
  isEditInProgress,
  onRefreshNow,
}: TCanvasStatusBadgeProps) => {
  const { variant, label, hasDot } =
    WorkflowCanvasRefreshHelper.getRefreshBadgeConfig(
      isRefreshing,
      isEditInProgress,
      lastUpdatedAt
    );

  return (
    <div className="flex items-center gap-xs rounded-full border border-border-primary bg-bg-primary py-xs pl-md pr-xs shadow-md">
      <Badge variant={variant} size="sm" hasDot={hasDot}>
        {label}
      </Badge>
      <IconButton
        variant="default"
        size="sm"
        aria-label="Refresh the canvas"
        onClick={onRefreshNow}
        icon={<Icons.RefreshCw01 className="size-4" />}
      />
    </div>
  );
};
